import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;
let inflight = null;

export function usePaymentOptions() {
  const [opts, setOpts] = useState(cached);
  useEffect(() => {
    if (cached) return;
    inflight = inflight || api.get("/payments/options").then(({ data }) => { cached = data; return data; }).catch(() => ({}));
    inflight.then(setOpts);
  }, []);
  return opts || {};
}

export default function PayIn4({ price, className = "", testId = "pay-in-4-hint" }) {
  const { afterpay, klarna } = usePaymentOptions();
  if (!afterpay && !klarna) return null;
  const amt = Number(price || 0);
  if (!(amt >= 35 && amt <= 2000)) return null;
  const brands = [afterpay && "Afterpay", klarna && "Klarna"].filter(Boolean).join(" or ");
  return (
    <div className={`font-mono text-[11px] text-neutral-400 ${className}`} data-testid={testId}>
      or 4 interest-free payments of <span className="text-white">${(amt / 4).toFixed(2)}</span> with {brands}
    </div>
  );
}
